export enum CustomFieldRedactMethod {
    MaskNothing = 1,
    MaskAllCharacters = 2,
    ShowLastFourCharacters = 3
}


